/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type CogGearSvgrepoComSvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function CogGearSvgrepoComSvgIcon(props: CogGearSvgrepoComSvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlSpace={"preserve"}
      version={"1.1"}
      viewBox={"0 0 12 12"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M10.25 6c0-.124-.026-.241-.037-.363l1.608-1.554-1.25-2.166-2.132.61a4 4 0 0 0-.65-.37L7.25 0h-2.5l-.54 2.157a4 4 0 0 0-.649.37l-2.132-.61-1.25 2.166 1.608 1.554c-.01.122-.037.239-.037.363s.026.241.037.363L.179 7.917l1.25 2.166 2.132-.61q.307.213.65.37L4.75 12h2.5l.54-2.157a4 4 0 0 0 .649-.37l2.132.61 1.25-2.166-1.608-1.554c.01-.122.037-.239.037-.363M6 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
        }
      ></path>
    </svg>
  );
}

export default CogGearSvgrepoComSvgIcon;
/* prettier-ignore-end */
